// extracted by mini-css-extract-plugin
export default {"FS800":"#008610","titleSection":"G8bdc63","row":"G0a17c2","rowInCheckout":"G55c6c2","dash":"G8567f7","undiscountedBoxPrice":"Gb3acca","discountEmphasis":"G50162e"};